import { render, staticRenderFns } from "./PROFESSIONAL_SERVICE_Page.vue?vue&type=template&id=ddc41f98&"
import script from "./PROFESSIONAL_SERVICE_Page.vue?vue&type=script&lang=js&"
export * from "./PROFESSIONAL_SERVICE_Page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports